import axios from 'axios'

const MELI_PROVINCE_ENDPOINT = "https://api.mercadolibre.com/classified_locations/countries"

export default async function getProvinces (country_Id) {
    const response = await axios.get(`${MELI_PROVINCE_ENDPOINT}/${country_Id}`)
    if (response.status === 200) {
        return response.data.states
    }
    return null

}


